import { apiAction, apiFetch } from '../utils';
import snippets from './snippets';

const entity = snippets('emailSnippets');

function setMeta(result, collection) {
  result.ready = collection.ready;
  result.pending = collection.pending;
  result.error = collection.error;
}

/**
 * Returns all email snippets that can be sent via the "send email" workflow
 *
 * @param {object} state - redux state
 * @returns {Array} - an array of email snippets
 */
entity.allForWorkflow = (state) => {
  const emailSnippets = entity.all(state);

  let result = emailSnippets.filter((snippet) => snippet.include_in_workflow);

  setMeta(result, emailSnippets);

  return result;
};

const reducer = entity.reducer;
export {reducer as default, entity};
